import { Link } from 'react-router-dom';

const NotFound = () => {
    return (
        <div className="text-center">
            <div style={{ marginTop: "20px" }}>
                <h2>404 TRANG KHÔNG TỒN TẠI</h2>
            </div>
            <div style={{ textAlign: "center", marginTop: "20px" }}><Link style={{ fontSize: "18px", color: "#fff" }} className="btn btn-primary" to="/"><i className="fa fa-home" aria-hidden="true" /> Về trang chủ</Link></div>
        </div>
    );
};

export default NotFound;
